function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
const SvgComponent = /*#__PURE__*/forwardRef(({
  color,
  height,
  width,
  size,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 29",
    width: width || size,
    height: height || size
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "16.8628",
    cy: "12.1372",
    r: "9.1451",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2E5E1",
    stroke: "#828A90",
    d: "M24.8996 4.1002l-.3535.3535.3535-.3536c-4.4668-4.4668-11.7338-4.4668-16.2005 0-3.7801 3.7801-4.361 9.4044-1.742 13.8016L3.6688 21.19l-1.594 1.594-.494.494-.1354.1354-.0353.0354-.009.009-.0023.0023-.0006.0005-.0001.0002.3535.3536-.3536-.3536c-1.2194 1.2193-1.6506 3.1019-.3908 4.3619l.0002.0002.1697.1695c1.2598 1.2601 3.1426.8289 4.3619-.3905l-.3536-.3535.3536.3535.0002-.0002.0005-.0005.0023-.0023.009-.009.0353-.0353.1351-.1352.493-.4929 1.5905-1.5906 3.2932-3.2931c4.3971 2.619 10.0214 2.0382 13.8015-1.7419l-.3535-.3536.3535.3536c4.4668-4.4669 4.4667-11.7339 0-16.2007zM22.1698 6.83l.3535-.3536-.3535.3536c2.961 2.961 2.961 7.78 0 10.741-2.961 2.9608-7.7799 2.9608-10.741 0-2.961-2.961-2.961-7.78.0001-10.741 2.961-2.961 7.7799-2.961 10.7409 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828A90",
    d: "M11.7746 12.0205a1.129 1.129 0 01-.4402-.0897c-.5751-.2434-.8441-.5115-.6007-1.0866 1.5296-3.6147 5.7147-5.311 9.3294-3.7814.575.2433.844.5114.6006 1.0865-.2434.5751-.9067.844-1.482.6007-2.4662-1.0436-5.3218.1138-6.3653 2.58a1.1311 1.1311 0 01-1.0418.6905z"
  }));
});
SvgComponent.defaultProps = {
  size: 29
};
SvgComponent.propTypes = {
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;